export default __webpack_public_path__ + "static/media/marker.a405c266.png";